//Componentes generales
import React, { useReducer, useContext, useEffect } from "react";
import controlReducer from "./controlReducer";
import controlContext from "./controlContext";
import moment from "moment";

//Axios
import clienteAxios from "../../config/axios";

//Rutas de api
import { getProductsByTDocNroFor } from "../../api/product";
import {
  getTDocsByFiltrosRango,
  getTDocsByFiltrosRangoAndNroCta,
} from "../../api/transactionDocuments";
import { getProviders, uploadProvider } from "../../api/abmProvider";

//Socket
import { SocketContext } from "../socket/socket";

//Acciones
import {
  ACTUALIZAR_TDOC,
  AGREGAR_TDOC,
  ELIMINAR_TDOC,
  MODIFICAR_FILTROS_ESTADOS,
  MODIFICAR_FILTROS_RANGO,
  INICIAR_FILTROS,
  SET_INICIAR_FILTROS_IS_LOADING,
  SET_ACTIVE_WORKSPACE,
} from "./controlActions";

//Estados de autorización
import { STATES_COMPROBANTE } from "../../utils/states";
import { filtrosToString } from "../../utils/funciones";
import { getUsersInGroupV } from "../../api/user";
import { getGroupByUser } from "../../api/group";
import authContext from "../authentication/authContex";

//Valores iniciales
const initialState = {
  listTDoc: null,
  listTDocBase: null,
  filtrosRango: {
    fecAlt: {
      //desde: new Date(moment("01/01/1980", "DD/MM/YYYY").toDate()),
      desde: moment.utc().subtract(365, "days").startOf('day').toDate(),
      hasta: moment.utc().endOf('day').toDate(), // 23:59:59
    },
    dateOfIssue: {
      //desde: new Date(moment("01/01/1980", "DD/MM/YYYY").toDate()),
      desde: moment.utc().subtract(365, "days").startOf('day').toDate(),
      hasta: moment.utc().endOf('day').toDate(), // 23:59:59
    },
  },
  filtrosEstado: {
    state: STATES_COMPROBANTE,
    tDocAbmProvider: [{}],
    gruposV: [],
    importe: {
      desde: null,
      hasta: null,
    },
    ocsApl: [],
  },
  filtrosEstadoPredeterminado: null,
  cargando: false,
  iniciarFiltrosIsLoading: false,
  activeWorkSpace: {
    pendientes: 1,
    enEspera: 0,
    autorizados: 0,
    todos: 0,
  }
};

/* 
    State encargado de la gestión de filtros y listado de comprobantes. (No se encuentra tan en uso, en la mayoria fue reemplazado por controlGLB).
*/
const ControlState = (props) => {
  const server = useContext(SocketContext);
  const { usuario } = useContext(authContext);

  /* 
        Disparadores que sincronizan la lista de comprobantes ante la creación de un comprobante.
    */
  useEffect(() => {
    if (server) {
      //TDoc Nuevo
      server.on("addTDoc", (tDoc) => {
        console.log("RECIBO EL TDOC CREADO");
        dispatch({
          type: AGREGAR_TDOC,
          payload: tDoc,
        });
      });

      return () => server.off("addTDoc");
    }
  }, [server]);

  /*
        Disparadores que sincronizan la lista de comprobantes ante la modificación de un comprobante.
    */
  useEffect(() => {
    if (server) {
      //TDoc Modificado
      server.on("modTDoc", ({ tDoc }) => {
        dispatch({
          type: ACTUALIZAR_TDOC,
          payload: tDoc,
        });
      });

      return () => server.off("modTDoc");
    }
  }, [server]);

  /* 
        Disparadores que sincronizan la lista de comprobantes ante la elimincación de un comprobante.
    */
  useEffect(() => {
    if (server) {
      //TDoc Eliminado
      server.on("deletedTDoc", (tDoc) => {
        console.log("RECIBO EL TDOC ELIMINADO");
        dispatch({
          type: ELIMINAR_TDOC,
          payload: tDoc,
        });
      });

      return () => server.off("deletedTDoc");
    }
  }, [server]);

  const [state, dispatch] = useReducer(controlReducer, initialState);

  //Logica del control state;

  //Inicializa los filtros dependiendo del usuarios
  const iniciarFiltros = async (activeWorkSpace, usuario = "") => {

    // Indicar que los filtros están siendo reiniciados para evitar parpadeo
    dispatch({
      type: SET_INICIAR_FILTROS_IS_LOADING,
      payload: true,
    });

    try {
      console.log("Entra en inciar Filtros");
      //Paso todos los dates de los filtros rango a un valor valido ademas de transfor en cadena de string para pasar en peticion get.
      const filtrosString = filtrosToString(initialState.filtrosRango);

      let respTDocs;
      let proveedores = [];
      let gruposV = [];

      // Si se encuentra usuario.nroCta, significa que es un proveedor
      if (usuario.nroCta !== null && usuario.nroCta.trim() !== "") {
        //Relizo peticion con los parametros de rango y el usuario en sesion
        respTDocs = await getTDocsByFiltrosRangoAndNroCta(
          usuario.nroCta,
          filtrosString
        );
        proveedores.push({ nroCta: usuario.nroCta, nombre: usuario.fullName });
      } else {
        respTDocs = await getTDocsByFiltrosRango(filtrosString);

        console.log("ENTRO AL ACTUALIZAR PROVEEDORES");
        const respProveedores = await getProviders();
        proveedores = respProveedores.data.data.map((p) => ({
          nroCta: p.nroCta,
          nombre: p.nombre,
        }));
        proveedores.push({ nroCta: "", nombre: "" });

        const respGruposUsuario = await getGroupByUser(usuario._id);

        gruposV = respGruposUsuario.data.data.map((g) => ({
          _id: g.grupo._id,
          name: g.grupo.name,
        }));
        //gruposV.push({ _id: "", name: ""});
      }

      console.log(respTDocs);
      console.log(filtrosString);

      let state = [];
      if (activeWorkSpace.todos == 1) {
        state = STATES_COMPROBANTE;
      } else if (activeWorkSpace.pendientes == 1) {
        state = ["PENDIENTE"];
      } else if (activeWorkSpace.autorizados == 1) {
        state = ["AUTORIZADO"];
      }

      const filtrosEstado = {
        ...initialState.filtrosEstado,
        state: state,
        tDocAbmProvider: proveedores,
        gruposV: gruposV,
        importe: { desde: null, hasta: null },
        ocsApl: [],
      };

      const filtrosRango = { ...initialState.filtrosRango };

      const listaComprobantes = respTDocs.data.data;

      dispatch({
        type: INICIAR_FILTROS,
        payload: {
          tDocs: listaComprobantes,
          filtrosEstado: filtrosEstado,
          filtrosRango: filtrosRango,
        },
      });
      dispatch({
        type: MODIFICAR_FILTROS_RANGO,
        payload: { filtrosRango, listaComprobantes },
      });
      // Indicar que los filtros terminaron de cargarse
      dispatch({
        type: SET_INICIAR_FILTROS_IS_LOADING,
        payload: false,
      });
    } catch (error) {
      console.log(error);
      console.log("Error a la hora de iniciar filtros");
      // Indicar que los filtros terminaron de cargarse incluso en caso de error
      dispatch({
        type: SET_INICIAR_FILTROS_IS_LOADING,
        payload: false,
      });
    }
  };

  //Modifica los filtros de rango y trae los tDocs acorde a los parametros enviados
  const modificarFiltrosRango = async (nroCta, filtrosRango) => {
    const filtrosString = filtrosToString(filtrosRango);

    let respTDocs;

    if (nroCta !== null && nroCta.trim() !== "") {
      //Relizo peticion con los parametros de rango y el usuario en sesion
      respTDocs = await getTDocsByFiltrosRangoAndNroCta(nroCta, filtrosString);
    } else {
      respTDocs = await getTDocsByFiltrosRango(filtrosString);
    }

    const listaComprobantes = respTDocs.data.data;

    dispatch({
      type: MODIFICAR_FILTROS_RANGO,
      payload: { filtrosRango, listaComprobantes },
    });
  };

  //Modifica los filtros de estado
  const modificarFiltrosEstado = (filtrosEstados) => {
    dispatch({
      type: MODIFICAR_FILTROS_ESTADOS,
      payload: filtrosEstados,
    });
  };

  //Filtra una lista de tDoc de acuerdo a los filtros
  const filtrar = (lista, filtrosEstado, usuario) => {
    if (!lista || lista === undefined) return [];

    const listaFiltrada = lista.filter((item) => {
      const importeItem = parseFloat(item.importe);
      const importeDesde = parseFloat(filtrosEstado.importe.desde);
      const importeHasta = parseFloat(filtrosEstado.importe.hasta);

      const aplicarFiltroImporte = !isNaN(importeDesde) || !isNaN(importeHasta);

      const enRangoImporte =
        (!isNaN(importeDesde) ? importeItem >= importeDesde : true) &&
        (!isNaN(importeHasta) ? importeItem <= importeHasta : true);

      // Si no se encuentra usuario.nroCta, significa que no es un proveedor
      const aplicarFiltroGruposV = !(
        usuario.nroCta && usuario.nroCta.trim() !== ""
      );

      // Filtro por gruposV
      const cumpleFiltroGruposV =
        !aplicarFiltroGruposV ||
        item.gruposV.some((grupoItem) =>
          filtrosEstado.gruposV.some(
            (filtroGrupo) => grupoItem._id === filtroGrupo._id
          )
        );

      return (
        filtrosEstado.state.includes(item.state) &&
        filtrosEstado.tDocAbmProvider
          .map((prov) => prov.nroCta)
          .includes(item.nroCta) &&
        (!aplicarFiltroImporte || enRangoImporte) &&
        (filtrosEstado.ocsApl.length === 0 || filtrosEstado.ocsApl.some((filtroOc) => item.ocsApl?.some((oc) => String(oc.nroFor) === String(filtroOc.value)))) &&
        cumpleFiltroGruposV
      );
    });

    return listaFiltrada;
  };

  //Auxiliar
  const getProductsByNroFor = async (tDocCodFor, tDocNroFor) => {
    try {
      const resp = await getProductsByTDocNroFor(tDocCodFor, tDocNroFor); //clienteAxios.get(`/productBytDocNroFor/${tDocCodFor}/${tDocNroFor}`);
      return resp.data.data;
    } catch (error) {
      console.log(error.response);
    }
  };

  //Modifica el workspace activo
  const setActiveWorkSpace = (workspace) => {
    dispatch({
      type: SET_ACTIVE_WORKSPACE,
      payload: workspace,
    });
  };

  return (
    <controlContext.Provider
      value={{
        listTDoc: state.listTDoc,
        listTDocBase: state.listTDocBase,
        cargando: state.cargando,
        filtrosEstado: state.filtrosEstado,
        filtrosRango: state.filtrosRango,
        iniciarFiltrosIsLoading: state.iniciarFiltrosIsLoading,
        activeWorkSpace: state.activeWorkSpace,
        iniciarFiltros,
        modificarFiltrosEstado,
        modificarFiltrosRango,
        filtrar,
        getProductsByNroFor,
        setActiveWorkSpace
      }}
    >
      {props.children}
    </controlContext.Provider>
  );
};

export default ControlState;

/*
    Función para aplicar los filtros.
        Donde filtros son los filtros.
*/
/*     const aplicarFiltros = async (filtros) => {

        let list = state.listTDoc;
        //Hay que pasar filtros a date
        try {
            if (
                moment(new Date(state.filtros.fecAlt.desde)).isSame(new Date(filtros.fecAlt.desde), 'day') !== true ||
                moment(new Date(state.filtros.fecAlt.hasta)).isSame(new Date(filtros.fecAlt.hasta), 'day') !== true ||
                moment(new Date(state.filtros.deliveryDate)).isSame(new Date(filtros.deliveryDate), 'day') !== true
            ) {

                filtros.fecAlt.desde = new Date(filtros.fecAlt.desde);
                filtros.fecAlt.hasta = new Date(filtros.fecAlt.hasta);
                filtros.deliveryDate = new Date(filtros.deliveryDate);

                const filtros = { fecAlt: filtros.fecAlt, deliveryDate: filtros.deliveryDate };
                const resp = await  getTDocByFilter(filtros);//clienteAxios.post('/transactionDocument/filter', { fecAlt: filtros.fecAlt, deliveryDate: filtros.deliveryDate });
                list = resp.data.data;

                dispatch({
                    type: APLICAR_FILTROS,
                    payload: {
                        listTDoc: resp.data.data,
                        filtros: filtros
                    }
                });



            } else {

                dispatch({
                    type: APLICAR_FILTROS,
                    payload: {
                        filtros: filtros
                    }
                });

            }

            return { lista: list, filtros: filtros };

        } catch (error) {
            console.log(error);
            console.log("Error a la hora de APLICAR filtros");
        } finally {
            dispatch({
                type: CARGANDO_CONTROL,
                payload: false
            })
        }
    }; */